import enumPart from './enumPart';

// util
import objectHelper from '../util/objectHelper';

let e = objectHelper.merge(enumPart, {

    MINI_PROGRAM: {
        code: 25,
        title: '小程序'
    }

});

export default e;
